import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
declare var $: any;
import { ActivatedRoute, Params, Router } from "@angular/router";
import * as moment from "moment";
import { LosService } from "src/app/_LOS/services/los.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";

@Component({
    selector: 'app-mst-process-employee',
    templateUrl: './mst-process-employee.component.html',
    styleUrls: ['./mst-process-employee.component.scss'],
    standalone: false
})
export class MstProcessEmployeeComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  loginUserId: number = 0;
  ProcessList: any[] = [];
  ProcessIds: any = 0;
  ProcessDropdown: any = [];
  BranchesList: any = [];
  BranchId: any[] = [];
  branchDropdownSettings: any = {};
  ProductList: any = [];
  ProductId: any[] = [];
  productDropdownSettings: any = {};


  // Two tabs: Assigned (search) & Unassigned (lazy load on tab change)
  AssignedDataSource: any;
  AssigneddisplayedColumns: string[] = [
    "EmpId",
    "Employee_Name",
    "Role_Name",
    "Action"
  ];

  UnassignedDataSource: any;
  UnassigneddisplayedColumns: string[] = [
    "EmpId",
    "Employee_Name",
    "Role_Name",
    "Action"
  ];

  // Confirmation modal variables
  selectedEmployee: any = null;
  isAssignMode: boolean = true;
  selectedProcessName: string = '';
  // Tracks if Unassigned tab data is already loaded
  unassignedLoaded: boolean = false;
  // Current tab index: 0=Assigned, 1=Unassigned
  selectedTabIndex: number = 0;

  DataSourceDetail: any;
  displayedColumnsDetails: string[];

  constructor(private dataSharingService: DataSharingService,
      private snackBar: MatSnackBar,
      private route: ActivatedRoute,
      private lmsService: LmsService,
      private _QuickLoanService: QuickLoanService,
      private _MasterService: MasterService,
      private losService: LosService,
      private _Route: Router,
      private _EncrDecrService: EncrDecrService) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.loginUserId = this.currentUser?.userId || 0;
    this.dataSharingService.HeaderTitle.next("Process Employee");
    this.QuickLoan_ProcessMaster();
    this.getBranchesList();
    this.getProductDropdown();
    this.initializeDropdownSettings();
  }

  // Load process dropdown
  QuickLoan_ProcessMaster() {
    this._QuickLoanService.QuickLoan_ProcessMaster().subscribe((res: any) => {
      this.ProcessDropdown = res;
    });
  }

  // Search → fetch Assigned employees; Unassigned loads on tab change (lazy)
  OnSearchProcessEmployee() {
    // If no process selected, show toast and return
    if (!this.ProcessIds || this.ProcessIds === 0) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'Please Select Process', ...this.configSuccess });
      return;
    }

    this.showSpinner = true;
    this.unassignedLoaded = false;
    this.UnassignedDataSource = null;

    this._QuickLoanService.Process_AssignedEmployees({
      ProcessId: this.ProcessIds,
      Type: 'Assigned',
      BranchId: this.getSelectedIds(this.BranchId, 'BranchId') || '',
      ProductId: this.getSelectedIds(this.ProductId, 'ProductId') || ''
    }).subscribe((res: any) => {
      this.AssignedDataSource = new MatTableDataSource(
        JSON.parse(JSON.stringify(res))
      );
      this.showSpinner = false;
    });

    // Also load Unassigned if user is on that tab
    if (this.selectedTabIndex === 1) {
      this.loadUnassignedEmployees();
    }
  }

  //Multi-Select

    getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  getProductDropdown() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }

  initializeDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };

    this.productDropdownSettings = {
      singleSelection: false,
      idField: "ProductId",
      textField: "Product",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter:true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "";
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) return [];
    if (!selectedItems?.length) return items;

    const selectedIds = selectedItems.map((s) => s[key]);
    const selected = items.filter((i) => selectedIds.includes(i[key]));
    const rest = items.filter((i) => !selectedIds.includes(i[key]));
    return [...selected, ...rest];
  }

  onBranchSelectionChange() {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.BranchId,
      "BranchId"
    );
  }

  onProductSelectionChange() {
    this.ProductList = this.moveSelectedItemsToTop(
      this.ProductList,
      this.ProductId,
      "ProductId"
    );
  }



  // On tab change — load Unassigned only when that tab is selected
  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    if (event.index === 1 && !this.unassignedLoaded) {
      this.loadUnassignedEmployees();
    }
  }

  // Fetch Unassigned employees (lazy — only on first tab click)
  loadUnassignedEmployees() {
    this.showSpinner = true;
    this._QuickLoanService.Process_AssignedEmployees({
      ProcessId: this.ProcessIds,
      Type: 'Unassigned',
      BranchId: this.getSelectedIds(this.BranchId, 'BranchId') || '',
      ProductId: this.getSelectedIds(this.ProductId, 'ProductId') || ''
    }).subscribe((res: any) => {
      this.UnassignedDataSource = new MatTableDataSource(
        JSON.parse(JSON.stringify(res))
      );
      this.unassignedLoaded = true;
      this.showSpinner = false;
    });
  }

  // Open confirmation modal
  openConfirmModal(row: any, mode: 'Assign' | 'Unassign') {
    this.selectedEmployee = row;
    this.isAssignMode = (mode === 'Assign');

    const selectedProc = this.ProcessDropdown.find(
      (p: any) => p.ProcessId === this.ProcessIds
    );
    this.selectedProcessName = selectedProc ? selectedProc.Process_Name : '';

    $('#confirmActionModal').modal('show');
    $('#confirmActionModal').css('z-index', '1050');
  }

  // Close modal
  onCancelConfirmModal() {
    $('#confirmActionModal').modal('hide');
    this.selectedEmployee = null;
  }

  // Confirm → Save_AssignedEmployees API; on success close modal, snackbar, refresh
  onConfirmAction() {
    const empName = this.selectedEmployee?.Employee_Name || 'Employee';
    const procName = this.selectedProcessName || 'this process';

    this._QuickLoanService.Save_AssignedEmployees({
      ProcessId: this.ProcessIds,
      EmpId: this.selectedEmployee?.EmpId,
      Type: this.isAssignMode ? 'Assigned' : 'Unassigned',
      LoginUserId: this.loginUserId,
      BranchId: this.getSelectedIds(this.BranchId, 'BranchId') || '',
      ProductId: this.getSelectedIds(this.ProductId, 'ProductId') || ''
    }).subscribe((res: any) => {
      const result = Array.isArray(res) ? res[0] : res;
      if (result && (result.CODE === 0 || result.CODE === 1)) {
        this.onCancelConfirmModal();
        const msg = this.isAssignMode
          ? `"${empName}" has been assigned to ${procName}`
          : `"${empName}" has been unassigned from ${procName}`;
        this.snackBar.openFromComponent(SnackbarComponent, { data: msg, ...this.configSuccess });
        this.refreshBothTabs();
      } else {
        this.onCancelConfirmModal();
        this.snackBar.openFromComponent(SnackbarComponent, { data: result?.Msg || 'Something went wrong!', ...this.configSuccess });
      }
    });
  }

  // Refresh both tabs (Unassigned only if already loaded)
  refreshBothTabs() {
    this._QuickLoanService.Process_AssignedEmployees({
      ProcessId: this.ProcessIds,
      Type: 'Assigned',
      BranchId: this.getSelectedIds(this.BranchId, 'BranchId') || '',
      ProductId: this.getSelectedIds(this.ProductId, 'ProductId') || ''
    }).subscribe((res: any) => {
      this.AssignedDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
    });

    if (this.unassignedLoaded) {
      this._QuickLoanService.Process_AssignedEmployees({
        ProcessId: this.ProcessIds,
        Type: 'Unassigned',
        BranchId: this.getSelectedIds(this.BranchId, 'BranchId') || '',
        ProductId: this.getSelectedIds(this.ProductId, 'ProductId') || ''
      }).subscribe((res: any) => {
        this.UnassignedDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
      });
    }
  }

  // SnackBar config
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

}
